'use client';
import * as React from "react";
import { renderDivider_unstable } from "./renderDivider.js";
import { useDivider_unstable } from "./useDivider.js";
import { useDividerStyles_unstable } from "./useDividerStyles.styles.js";
import { useCustomStyleHook_unstable } from "@fluentui/react-shared-contexts";
/**
 * A divider visually segments content into groups.
 */ export const Divider = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = useDivider_unstable(props, ref);
    useDividerStyles_unstable(state);
    useCustomStyleHook_unstable('useDividerStyles_unstable')(state);
    return renderDivider_unstable(state);
});
Divider.displayName = 'Divider';
